module.exports = __webpack_public_path__ + "img/about_bg.e8988085.jpg";